import * as m from './jigsaw-methods';
import { createResetAction } from '../redux-util/async-helpers';
import * as sel from './page-context-selectors';
import {
  getBrandId,
  getJigsawHost,
} from '../redux-watson/watson-config-selectors';

export function createJigsawAction(apiCall) {
  return function(...args) {
    return {
      jigsaw: {
        apiCall,
        args,
        targetReader: false,
      },
    };
  };
}

export function createJigsawEventAction(eventName) {
  return function(data) {
    let dataToUse = data;
    if (typeof data === 'string' || typeof data === 'number') {
      dataToUse = {
        value: data,
      };
    }

    return {
      type: eventName,
      data: {
        ...dataToUse,
        timestamp: new Date().valueOf(),
      },
    };
  };
}

export function createJigsawReaderAction(apiCall) {
  return function(...args) {
    return {
      jigsaw: {
        apiCall,
        args,
        targetReader: true,
      },
    };
  };
}

export const getBookList = createJigsawAction(m.GET_BOOK_LIST);
export const createPageViewer = createJigsawAction(m.CREATE_PAGE_VIEWER);
export const hasNextPage = createJigsawReaderAction(m.HAS_NEXT_PAGE);
export const hasPrevPage = createJigsawReaderAction(m.HAS_PREV_PAGE);
export const getNextPage = createJigsawReaderAction(m.GET_NEXT_PAGE);
export const getPrevPage = createJigsawReaderAction(m.GET_PREV_PAGE);
export const getToc = createJigsawReaderAction(m.GET_TOC);
export const getUserInfo = createJigsawAction(m.GET_USER_INFO);
export const goToPage = createJigsawReaderAction(m.GO_TO_PAGE);
export const searchContent = createJigsawReaderAction(m.SEARCH_CONTENT);
export const goToCfi = createJigsawReaderAction(m.GO_TO_CFI);
export const getThumbnails = createJigsawReaderAction(m.GET_THUMBNAILS);
export const goToSearchResult = createJigsawReaderAction(m.GO_TO_SEARCH_RESULT);
export const destroy = createJigsawReaderAction(m.DESTROY);
export const enableScrolling = createJigsawReaderAction(m.ENABLE_SCROLLING);
export const disableScrolling = createJigsawReaderAction(m.DISABLE_SCROLLING);
export const getDevices = createJigsawAction(m.GET_DEVICES);
export const deactivateDevice = createJigsawAction(m.DEACTIVATE_DEVICE);
export const getCitation = createJigsawReaderAction(m.GET_CITATION);
export const getPageBreaks = createJigsawReaderAction(m.GET_PAGE_BREAKS);
export const clearSelection = createJigsawReaderAction(m.CLEAR_SELECTION);
export const setUserInfo = createJigsawAction(m.SET_USER_INFO);
export const scrollToTop = createJigsawReaderAction(m.SCROLL_TO_TOP);
export const scrollToLeft = createJigsawReaderAction(m.SCROLL_TO_LEFT);

const nextPageInternal = createJigsawReaderAction(m.NEXT_PAGE);
export function nextPage() {
  return function(dispatch, getState) {
    if (sel.hasNextPage(getState())) {
      dispatch(nextPageInternal());
    }
  };
}

const prevPageInternal = createJigsawReaderAction(m.PREV_PAGE);
export function prevPage() {
  return function(dispatch, getState) {
    if (sel.hasPrevPage(getState())) {
      dispatch(prevPageInternal());
    }
  };
}

export function navToThumb(thumb) {
  return function(dispatch) {
    dispatch(goToPage(thumb.label));
  };
}

export function resetSearch() {
  return function(dispatch) {
    dispatch(createResetAction(m.SEARCH_CONTENT));
  };
}

export function tryClearSelection() {
  return function(dispatch) {
    if (window.watsonViewer) {
      dispatch(clearSelection());
    }
  };
}

export function setLastBrandAccessed() {
  return function(dispatch, getState) {
    const lastBrandAccessed = getBrandId(getState());
    dispatch(setUserInfo({ lastBrandAccessed }));
  };
}

export function setJigsawHost() {
  return function(dispatch, getState) {
    const jigsawHost = getJigsawHost(getState());
    if (window.Jigsaw && jigsawHost) {
      window.Jigsaw.host = jigsawHost;
    }
  };
}
